<template>
    <div v-on:keyup.esc="close()" class="dialog draggable-item bg-light light center text-small overflow w-100-sm w-100-md w-75-lg  w-50-xl" v-cloak>

        <DialogTitle :title="repository.id == null ? $t('Add Repository') : repository.name" :defaultTitle="repository.id == null ? $t('Add Repository') : $t('Edit Repository')" :subTitle="repository.type_name" @closeDialog="close()" />

        <div class="dialog-content">


            <div class="form-group p-3 w-75">
                <span>{{ $t("Name") }}*</span>
                <input data-role="input" type="text" v-model.trim="repository.name" maxlength="50" :placeholder="$t('enter name')" data-prepend="<span class=' mif-pencil'></span>" v-fsitem />

            </div>
            <!------------------------------SCELTA DEL SERVICE ACCOUNT--------------------------------------------------------------->

            <!--Questa pagina deve implementare il metodo "sendSATestResult"-->
            <SARepoSelect class="form-group p-3" :type="repository.type" :idSA="repository.id_service_account" :idRepo="-2" @sendSATestResult="sendSATestResult" ref="saRepoSelect" />

            <!----------------------------------SCELTA DEL PERCORSO------------------------------------------------------------------>

            <div class="form-group p-3" :disabled="repository.id_service_account == -2 || !testResult.ok">
                <span>{{ $t("Select a path") }}:</span>
                <!--Nota : Se l'utente deve scegliere il sottopercorso, mostro solo il bottone.-->
                <div class="d-flex flex-row flex-align-baseline">
                    <input v-if="selectedNodes.length == 0" type="text" data-role="input" class="w-75 text-small" :disabled="testResult.client == null" v-path="repository.type" />
                    <input v-else type="text" data-role="input" v-model="selectedNodes[0].path" :disabled="testResult.client == null" class="w-75 text-small" v-path="repository.type" />
                    <!--a class="button ml-2" @click.prevent="testResult.client && handleToggleClick()" :class="{ disabled: !testResult.client }" v-disable-tooltip-extended="$t('Path selection is available only after a successful account test.')"><span class="mif-folder" /></a-->
                    <button class="button ml-2" :disabled="testResult.client == null || isObjectLockServiceAccount" @click="handleToggleClick" v-disable-tooltip="$t('Path selection is available only after a successful account test.')">
                        <span class="mif-folder"></span>
                    </button>
                </div>

                <div v-if="isObjectLockServiceAccount" class="fg-cobalt text-small mt-2">
                    <p class="mb-1">{{ $t("This service account is configured for Object Lock / immutability. Enter the bucket path manually; if the bucket does not exist, it will be created with Object Lock enabled so backups can be protected from deletion for the configured retention period.") }}</p>
                    <p class="mb-0">{{ $t("Use forward slashes (/) as path separators. Do not use backslashes (\\).") }}</p>
                </div>

                <div v-if="repository.type.isCloud()" class="text-small text-muted mt-1">{{ $t("If no path is selected, the cloud root will be used.") }}</div>
            </div>

        </div>

        <!-------------------------------------SALVATAGGIO-------------------------------------------------------------->
        <div class="dialog-actions">
            <div v-if="saveButton_disabled_message != ''" class="mr-auto w-50 p-0 fg-cobalt" :title="saveButton_disabled_message">
                <pre class="text-small text-truncate">{{ saveButton_disabled_message }}</pre>
            </div>

            <button class="button secondary ml-2" :disabled="!enableSaveButton" @click="save" v-disable-tooltip:saveButton_disabled_message>
                {{ $t("Save") }}
            </button>
        </div>
    </div>
</template>

<script>
import DialogTitle from "../../utils/DialogTitle";
import SARepoSelect from "../../utils/SARepoSelect";
import { isValid, getNodeType } from "../../../utils/utilitiesmodule";
import { draggableMixin } from '../../../mixins/draggable-mixin'
import { FileSystemSidebarConfig } from "../../../models/TreeNode";
import { saveRepository } from "../../../utils/entityMethods/repository";
import { disconnectServiceAccount, getSARootPath } from "../../../utils/entityMethods/serviceAccount";


export default {

    mixins: [draggableMixin],
    name: "Repository",
    props: {
        repository: Object,
    },
    components: {
        "DialogTitle": DialogTitle,
        SARepoSelect
    },
    watch: {
        selectedNodes: {
            handler: function (value) {
                if (value.length == 0) {
                    return;
                }

                this.setPathAndName(value[0].path);
            }
        }
    },
    data: function () {
        return {
            selectedNodes: [],
            testResult: {
                ok: false,
                okNumber: 0,
                serviceAccount: { id: -2, type: this.repository.type },
                client: null,// il client della piattaforma che effettuerà le richieste dei list
                list: null,
            },

            saveButton_disabled_message: ""
        }
    },

    computed: {
        enableSaveButton() {

            if (this.repository.id_service_account == -2) {
                this.saveButton_disabled_message = this.$t("Select and validate a service account");
                return false;
            }

            if (!this.testResult.ok) {
                this.saveButton_disabled_message = this.$t('You can save the repository only if the account test is successful.');
                return false;
            }


            if (this.repository.name == "") {
                this.saveButton_disabled_message = this.$t("Insert a name");
                return false;
            }

            if (this.isObjectLockServiceAccount && this.repository.path.includes("\\")) {
                this.saveButton_disabled_message = this.$t("Use forward slashes (/) as path separators. Do not use backslashes (\\).");
                return false;
            }

            this.saveButton_disabled_message = "";
            return true;
        },
        isObjectLockServiceAccount() {
            const options = this.testResult.serviceAccount?.options;
            return options != null && (options.objLock_enabled == 1 || options.objLock_enabled == 1);
        }
    },
    created() {

        //Se si sta creando un nuovo repository, non devo effettuare alcun controllo
        if (!isValid(this.repository.id)) {
            this.selectedNodes.push({
                path: "",
                type: getNodeType(this.repository.type, false)
            });
            return;
        }


        //Controllo se il service account esiste ancora
        this.testResult.serviceAccount = this.$session.getServiceAccountWithID(this.repository.id_service_account);

        //Se il service account è stato cancellato, pulisco il percorso che era salvato
        if (this.testResult.serviceAccount == null) {
            this.repository.path = "";
            this.testResult.serviceAccount = { id: -2, type: this.repository.type };
            //return;
        }

        this.selectedNodes.push({
            path: this.repository.path,
            type: getNodeType(this.repository.type, false)
        });


    },

    beforeDestroy: function () {
        this.close();
    },
    methods: {
        disconnectServiceAccount,
        getSARootPath,

        handleToggleClick() {
            if (this.testResult.client == null) return
            if (this.isObjectLockServiceAccount) return
            this.toggleFileSystemSidebar();
        },


        sendSATestResult(testResult) {
            this.testResult = testResult;
            this.repository.id_service_account = testResult.serviceAccount.id;
            /*if (this.testResult.ok && !isValid(this.repository.id)) {
                this.selectedNodes.splice(0, 1);
            }*/
            //if ([this.$ONEServiceType.Network, this.$ONEServiceType.FTP].includes(testResult.serviceAccount.type)) {
            this.selectedNodes[0].path = this.getSARootPath(testResult.serviceAccount);
            this.setPathAndName(this.selectedNodes[0].path);
            //}
        },
        async toggleFileSystemSidebar() {
            if (this.isObjectLockServiceAccount) {
                return;
            }

            if (isValid(this.testResult.serviceAccount.options.lastTestPC) && this.$root.connectionsStates[this.testResult.serviceAccount.options.lastTestPC]) {
                var pc = this.$session.getPCWithID(this.testResult.serviceAccount.options.lastTestPC);
                await this.$root.socket("SETPC", pc);
            }

            var config = FileSystemSidebarConfig.getForDestination(
                this.repository.type,
                this.testResult.client,
                this.getSARootPath(this.testResult.serviceAccount),
                this.repository.type != this.$ONEServiceType.FileFolder
            );

            this.$root.$emit("toggleFileSystemSidebar", this.selectedNodes, config);
        },

        async save() {
            let self = this;
            this.$root.$emit("closeFileSystemSidebar");
            self.repository.path = this.selectedNodes[0].path;
            if (self.repository.type == this.$ONEServiceType.FTP && !self.repository.path.startsWith(this.testResult.serviceAccount.url))
                self.repository.path = this.testResult.serviceAccount.url + "/" + self.repository.path;
            await this.saveRepository(self.repository);
        },
        saveRepository,
        close() {
            this.$root.$emit('CLOSEREPOSITORYDIALOG');
            this.$root.$emit("closeFileSystemSidebar");
            //In caso di ftp o network, eseguo la disconnessione
            if (this.testResult.ok) {
                this.disconnectServiceAccount(this.testResult.client.serviceAccount);
                if (this.$session.getRoomPC() == null) {
                    this.$root.socket("SETPC", null);
                }
            }
        },

        setPathAndName(path) {
            if (this.repository.id != null && !this.testResult.ok) {
                return;
            }

            var config = {
                path: path,
                type: this.repository.type
            };

            if ([this.$ONEServiceType.Network, this.$ONEServiceType.FTP].includes(this.repository.type)) {
                config.prefix = this.getSARootPath(this.testResult.serviceAccount);
            }

            if (this.repository.type != this.$ONEServiceType.FileFolder) {
                config.saName = this.testResult.serviceAccount.name;
            }

            [this.repository.path, this.repository.name] = this.$root.getPathAndName(config);

        },

        setPathAndName_old(path) {
            this.repository.path = path;

            if (this.repository.type == this.$ONEServiceType.FTP && !this.repository.path.startsWith(this.testResult.serviceAccount.url)) {
                this.repository.path = this.testResult.serviceAccount.url + "/" + this.repository.path;
            }

            // se il nome era già stato assegnato (sono in edit), non lo riassegno
            if (isValid(this.repository.id)) {
                return;
            }

            if (path == '') {
                this.repository.name = '';
                return;
            }


            switch (this.repository.type) {
                case this.$ONEServiceType.FileFolder:
                    path = path.trimEnd("\\").trimEnd(":");
                    this.repository.name = this.$session.getRoomPC().name + " - " + path.lastPartOfPath(); //nome pc + ultima parte del percorso
                    break;
                /*case this.$ONEServiceType.Network:
                case this.$ONEServiceType.FTP:
                    var partsOfPath = path.split(path.getSeparator()).filter(p =>p!='');
                    this.repository.name = partsOfPath[0] + " - " + partsOfPath.at(-1);
                    break;*/
                default:
                    this.repository.name = this.testResult.serviceAccount.name + " - " + path.lastPartOfPath();
                    break;
            }

        },
    }
}
</script>
